import { render, staticRenderFns } from "./candidate-magic-link.vue?vue&type=template&id=a3e74c80&"
import script from "./candidate-magic-link.vue?vue&type=script&lang=js&"
export * from "./candidate-magic-link.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports